var scope_0 = require('/home/runner/work/octicons/octicons/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4860c2b7e3bec0729c983d0d06487049.js').default;
var scope_1 = require('/home/runner/work/octicons/octicons/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/834db4a03fa0369606c81e236a51e22e.js').default;
var scope_2 = require('/home/runner/work/octicons/octicons/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    